var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"oauth-callback"},[_c('div',{staticClass:"loading-container"},[_c('i',{staticClass:"el-icon-loading"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$d('正在处理登录，请稍候...')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a7f8f32","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/oauth-callback.vue
// module id = null
// module chunks = 